const config = {
  apiUrl: 'https://api.logirate.org/',
  callbackUrlBase: 'https://api.logirate.org',
};

export default config;
